import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'globe-plus',
  size: 24,
  node: [
    [
      'path',
      { d: 'M15.929 10.563A14.5 14.5 0 0112 22a1 1 0 010-20 15 15 0 01.68.768', key: '15e7f6' },
    ],
    ['path', { d: 'M19 2v6', key: '4bpg5p' }],
    [
      'path',
      { d: 'M21.92 10.734A10 10 0 0112 22a14.5 14.5 0 010-20 10 10 0 011.266.08', key: 'iws0aw' },
    ],
    ['path', { d: 'M22 12H2', key: 'v4uh5a' }],
    ['path', { d: 'M22 5h-6', key: 'jo9hv5' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name GlobePlus
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUuOTI5IDEwLjU2M0ExNC41IDE0LjUgMCAwMTEyIDIyYTEgMSAwIDAxMC0yMCAxNSAxNSAwIDAxLjY4Ljc2OCIgLz4KICA8cGF0aCBkPSJNMTkgMnY2IiAvPgogIDxwYXRoIGQ9Ik0yMS45MiAxMC43MzRBMTAgMTAgMCAwMTEyIDIyYTE0LjUgMTQuNSAwIDAxMC0yMCAxMCAxMCAwIDAxMS4yNjYuMDgiIC8+CiAgPHBhdGggZD0iTTIyIDEySDIiIC8+CiAgPHBhdGggZD0iTTIyIDVoLTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/globe-plus
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GlobePlus = createLucideIcon(__iconData);

export default GlobePlus;
